import { gql } from '@apollo/client';

export const GET_PRICE_LIST_DATA_UNAUTH = gql`
  query getPriceListDataUnauth(
    $planId: Int
    $fileCategory: FileCategory
    $searchText: String
    $offset: Int
    $limit: Int
  ) {
    getPriceListDataUnauth(
      planId: $planId
      fileCategory: $fileCategory
      searchText: $searchText
      offset: $offset
      limit: $limit
    ) {
      totalItems
      offset
      data {
        serviceName
        billingCode
        codingSystem
        providersNPI
        tin
        planName
        entityName
        negotiatedRate
        negotiatedType
        negotiationArrangement
        placeOfServiceName
        entityType
        planIdType
        planId
        planMarketType
        lastUpdatedOn
        codingSystemVersion
        placeOfServiceCode
        expirationDate
      }
    }
  }
`;

export const GET_PRICE_LIST_FILE_DATA_UNAUTH = gql`
  query getPriceListFileDataUnauth($planId: Int, $fileCategory: FileCategory) {
    getPriceListFileDataUnauth(planId: $planId, fileCategory: $fileCategory) {
      data
    }
  }
`;

export const GET_COVERAGE_BY_AFFILIATE_UNAUTH = gql`
  query getAllCoverageByAffiliateUnauth {
    getAllCoverageByAffiliateUnauth {
      id
      name
      planId
      planTypeId
      isActive
    }
  }
`;

export const GET_DOWNLOAD_LINK_UNAUTH = gql`
  query getPriceListFileLinkUnauth($planId: Int, $fileCategory: FileCategory) {
    getPriceListFileLinkUnauth(planId: $planId, fileCategory: $fileCategory) {
      link
    }
  }
`;

export const GET_AFFILIATE_LOGO_URL = gql`
  query getAffiliateLogoURLUnauth($affiliateDnsName: String) {
    getAffiliateLogoURLUnauth(affiliateDnsName: $affiliateDnsName) {
      imageUrl
    }
  }
`;

export const GET_PRICELIST_DATA = gql`
  query getPriceListDocument($reqdata: PriceListRequest) {
    getPriceListDocument(priceListRequest: $reqdata) {
      serviceName
      billingCode
      providersNpi
      codingSystem
      negotiatedRate {
        min
        max
      }
      description
      tin
      allowedAmount {
        min
        max
      }
      negotiatedType
      planName
      planId
      entityName
      entityType
      planIdType
      lastUpdatedOn
      codingSystemVersion
      expirationDate
      negotiatedArrangement
    }
  }
`;

export const FIND_ALL_PLACES_OF_SERVICE = gql`
  query findAllPlacesOfServices($reqdata: FindCareRequest) {
    findAllPlacesOfServices(findCareRequest: $reqdata) {
      tin
      places {
        name
        negotiatedRate {
          min
          max
        }
      }
    }
  }
`;

export const FIND_ALL_SERVICES_QUERY = gql`
  query findAllServices($findCareRequest: FindCareRequest) {
    findAllServices(findCareRequest: $findCareRequest) {
      name
      billingCode
      negotiatedRate {
        min
        max
      }
    }
  }
`;

export const FIND_DISTINCT_SERVICES = gql`
  query findDistinctNameOfServices(
    $distinctServicesInput: DistinctServicesInput
  ) {
    findDistinctNameOfServices(distinctServicesInput: $distinctServicesInput)
  }
`;

export const FIND_SERVICE_NAME_BY_BILLING_CODE = gql`
  query findServiceNameByBillingCode($reqdata: FindCareRequest) {
    findServiceNameByBillingCode(findCareRequest: $reqdata) {
      name
    }
  }
`;

export const FIND_MODIFIERS_WITH_PLACE_OF_SERVICES = gql`
  query findDetailsByBillingCodeAndNpiCode($reqbody: FindCareRequest) {
    findDetailsByBillingCodeAndNpiCode(findCareRequest: $reqbody) {
      modifier
      serviceCodes {
        serviceCode
        placeOfService
        negotiatedRate
      }
    }
  }
`;

export const GET_MODIFIER_DETAILS = gql`
  query findAllModifiers($reqbody: ModifiersRequest) {
    findAllModifiers(modifiersRequest: $reqbody) {
      code
      description
    }
  }
`;